import React from "react";
import {
  DividerWrap,
  mentoringSeries,
  mentees,
  mentors
} from "./SalientComponents.js";

const Mentee = props => {
  return (
    <div
      data-midnight=""
      data-column-margin="default"
      data-bg-mobile-hidden=""
      className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
      style={{ paddingTop: "0px", paddingBottom: "0px" }}
    >
      <div className="row-bg-wrap">
        <div className="row-bg   " />
      </div>
      <div className="col span_12  left">
        <div
          className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column centered-text padding-1-percent"
          data-t-w-inherits="default"
          data-shadow="none"
          data-border-radius="none"
          data-border-animation=""
          data-border-animation-delay=""
          data-border-width="none"
          data-border-style="solid"
          data-border-color=""
          data-bg-cover=""
          data-padding-pos="all"
          data-has-bg-color="false"
          data-bg-color=""
          data-bg-opacity="1"
          data-hover-bg=""
          data-hover-bg-opacity="1"
          data-animation=""
          data-delay="0"
        >
          <div className="vc_column-inner">
            <a
              className="column-link"
              target="_blank"
              href={
                "/contact-detail-mentoring/" +
                props.mentee.name.replace(/\s/g, "") +
                "/" +
                props.mentee.id
              }
            />
            <div className="column-bg-overlay-wrap" data-bg-animation="none">
              <div className="column-bg-overlay" />
            </div>
            <div className="wpb_wrapper">
              <div
                className="nectar_icon_wrap"
                data-style="default"
                data-draw=""
                data-border-thickness="2px"
                data-padding="10px"
                data-color="extra-color-1"
              >
                <div className="nectar_icon">
                  <i
                    style={{
                      fontSize: "100px",
                      lineHeight: "100px",
                      height: "100px",
                      width: "100px"
                    }}
                    className="fa fa-user-circle"
                  />
                </div>
              </div>
              <div className="wpb_text_column wpb_content_element  vc_custom_1582668261432">
                <div className="wpb_wrapper">
                  <h4>{props.mentee.name}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column padding-2-percent"
          data-t-w-inherits="default"
          data-shadow="none"
          data-border-radius="none"
          data-border-animation=""
          data-border-animation-delay=""
          data-border-width="none"
          data-border-style="solid"
          data-border-color=""
          data-bg-cover=""
          data-padding-pos="all"
          data-has-bg-color="false"
          data-bg-color=""
          data-bg-opacity="1"
          data-hover-bg=""
          data-hover-bg-opacity="1"
          data-animation=""
          data-delay="0"
        >
          <div className="vc_column-inner">
            <div className="column-bg-overlay-wrap" data-bg-animation="none">
              <div className="column-bg-overlay" />
            </div>
            <div className="wpb_wrapper">
              <div className="wpb_text_column wpb_content_element  vc_custom_1583358204172">
                <div className="wpb_wrapper">
                  <h3>{props.series.name}</h3>
                  <h5 style={{ color: "#a3a3a3" }}>Your Role: Mentor</h5>
                </div>
              </div>

              <div
                className="nectar-cta "
                data-color="default"
                data-using-bg="false"
                data-style="see-through"
                data-display="block"
                data-alignment="left"
                data-text-color="custom"
              >
                <h6 style={{ color: "#1e83ec" }}>
                  <span className="text"> </span>
                  <span className="link_wrap">
                    <a
                      className="link_text"
                      href={
                        "/contact-detail-mentoring/" +
                        props.mentee.name.replace(/\s/g, "") +
                        "/" +
                        props.mentee.id
                      }
                    >
                      Details
                      <span className="arrow" />
                    </a>
                  </span>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Mentor = props => {
  return (
    <div
      data-midnight=""
      data-column-margin="default"
      data-bg-mobile-hidden=""
      className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
      style={{ paddingTop: "0px", paddingBottom: "0px" }}
    >
      <div className="row-bg-wrap">
        <div className="row-bg   " />
      </div>
      <div className="col span_12  left">
        <div
          className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column centered-text padding-1-percent"
          data-t-w-inherits="default"
          data-shadow="none"
          data-border-radius="none"
          data-border-animation=""
          data-border-animation-delay=""
          data-border-width="none"
          data-border-style="solid"
          data-border-color=""
          data-bg-cover=""
          data-padding-pos="all"
          data-has-bg-color="false"
          data-bg-color=""
          data-bg-opacity="1"
          data-hover-bg=""
          data-hover-bg-opacity="1"
          data-animation=""
          data-delay="0"
        >
          <div className="vc_column-inner">
            <a
              className="column-link"
              target="_blank"
              href={
                "/contact-detail-mentoring/" +
                props.mentor.name.replace(/\s/g, "") +
                "/" +
                props.mentor.id
              }
            />
            <div className="column-bg-overlay-wrap" data-bg-animation="none">
              <div className="column-bg-overlay" />
            </div>
            <div className="wpb_wrapper">
              <div
                className="nectar_icon_wrap"
                data-style="default"
                data-draw=""
                data-border-thickness="2px"
                data-padding="10px"
                data-color="extra-color-1"
              >
                <div className="nectar_icon">
                  <i
                    style={{
                      fontSize: "100px",
                      lineHeight: "100px",
                      height: "100px",
                      width: "100px"
                    }}
                    className="fa fa-user-circle"
                  />
                </div>
              </div>
              <div className="wpb_text_column wpb_content_element  vc_custom_1582668261432">
                <div className="wpb_wrapper">
                  <h4>{props.mentor.name}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column padding-2-percent"
          data-t-w-inherits="default"
          data-shadow="none"
          data-border-radius="none"
          data-border-animation=""
          data-border-animation-delay=""
          data-border-width="none"
          data-border-style="solid"
          data-border-color=""
          data-bg-cover=""
          data-padding-pos="all"
          data-has-bg-color="false"
          data-bg-color=""
          data-bg-opacity="1"
          data-hover-bg=""
          data-hover-bg-opacity="1"
          data-animation=""
          data-delay="0"
        >
          <div className="vc_column-inner">
            <div className="column-bg-overlay-wrap" data-bg-animation="none">
              <div className="column-bg-overlay" />
            </div>
            <div className="wpb_wrapper">
              <div className="wpb_text_column wpb_content_element  vc_custom_1584488490561">
                <div className="wpb_wrapper">
                  <h3>{props.series.name}</h3>
                  <h5 style={{ color: "#a3a3a3" }}>Your Role: Mentee</h5>
                </div>
              </div>

              <div
                className="nectar-cta "
                data-color="default"
                data-using-bg="false"
                data-style="see-through"
                data-display="block"
                data-alignment="left"
                data-text-color="custom"
              >
                <h6 style={{ color: "#1e83ec" }}>
                  <span className="text"> </span>
                  <span className="link_wrap">
                    <a
                      className="link_text"
                      href={
                        "/contact-detail-mentoring/" +
                        props.mentor.name.replace(/\s/g, "") +
                        "/" +
                        props.mentor.id
                      }
                    >
                      Details
                      <span className="arrow" />
                    </a>
                  </span>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const MentoringSeriesItem = props => {
  return (
    <div className="carousel-item">
      <div className="team-member" data-style="bio_fullscreen_alt">
        <div className="team-member-image">
          <div className="team-member-image-inner">
            <img
              src="http://xyz.idktechnology.com/wp-content/uploads/2020/03/Career-Transition-PRISM-Mentoring-Series-2.png"
              width="500"
              height="500"
              alt=""
            />
          </div>
        </div>
        <div className="team-member-overlay" />
        <div className="team-meta">
          <h3>{props.series.name}</h3>
          {props.series.shortDescription}
          <div
            className="nectar-cta"
            data-color="default"
            data-using-bg="false"
            data-style="arrow-animation"
            data-display="block"
            data-alignment="left"
          >
            <span className="link_wrap">
              <a className="link_text" href="#">
                <svg
                  className="next-arrow"
                  width="20px"
                  height="25px"
                  viewBox="0 0 50 80"
                  xmlSpace="preserve"
                >
                  <polyline
                    stroke="#000000"
                    strokeWidth="9"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    points="0, 0 45, 40 0, 80"
                  />
                </svg>
                <span className="line" style={{ backgroundColor: "#000" }} />
              </a>
            </span>
          </div>
        </div>
        <div className="nectar_team_bio_img" data-img-src="" />
        <div className="nectar_team_bio">
          {props.series.longDescription}
          <h5>Milestones</h5>
          <ul>
            {props.series.milestones != null &&
              props.series.milestones.length > 0 &&
              props.series.milestones.map(m => (
                <li key={m.id}>
                  {m.name}. {m.tasks.length} tasks to complete.
                </li>
              ))}
          </ul>
          <h5>Who is this series for?</h5>
          {props.series.who}
          <br />
          Send a Mentor Request (Button with diamond icon)
          <div className="bottom_meta">
            <a href="" target="_blank">
              <i className="icon-default-style fa fa-envira" />
            </a>
            <a href="" target="_blank">
              <i className="icon-default-style fa fa-diamond" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const MentoringPage = (props) => {
  return (
    <div>
      <div
        id="mentor-series"
        data-column-margin="default"
        data-midnight="dark"
        data-top-percent="6%"
        data-bottom-percent="6%"
        data-bg-mobile-hidden=""
        className="wpb_row vc_row-fluid vc_row full-width-section standard_section "
        style={{
          paddingTop: "calc(100vw * 0.06)",
          paddingBottom: "calc(100vw * 0.06)"
        }}
      >
        <div
          className="row-bg-wrap"
          data-bg-animation="none"
          data-bg-overlay="false"
        >
          <div className="inner-wrap">
            <div
              className="row-bg using-bg-color"
              style={{ backgroundColor: "#ffffff" }}
            />
          </div>
          <div className="row-bg-overlay" />
        </div>
        <div className="col span_12 dark left">
          <div
            className="vc_col-sm-12 wpb_column column_container vc_column_container col no-extra-padding"
            data-t-w-inherits="default"
            data-border-radius="none"
            data-shadow="none"
            data-border-animation=""
            data-border-animation-delay=""
            data-border-width="none"
            data-border-style="solid"
            data-border-color=""
            data-bg-cover=""
            data-padding-pos="all"
            data-has-bg-color="false"
            data-bg-color=""
            data-bg-opacity="1"
            data-hover-bg=""
            data-hover-bg-opacity="1"
            data-animation=""
            data-delay="0"
          >
            <div className="vc_column-inner">
              <div className="column-bg-overlay-wrap" data-bg-animation="none">
                <div className="column-bg-overlay" />
              </div>
              <div className="wpb_wrapper">
                <div
                  id="fws_5e7ea0e41b17f"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row standard_section  vc_custom_1567864668835   "
                  style={{ paddingTop: "0px", paddingBottom: "0px" }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-12 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div
                            className="nectar-split-heading"
                            data-animation-type="line-reveal-by-space"
                            data-animation-delay="0"
                            data-custom-font-size="false"
                          >
                            <h2>Available Mentoring Series</h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="owl-carousel"
                  data-enable-animation=""
                  data-loop="false"
                  data-animation-delay="0"
                  data-autorotate="true"
                  data-autorotation-speed="6000"
                  data-column-padding="20px"
                  data-desktop-cols="2"
                  data-desktop-small-cols="2"
                  data-tablet-cols="1"
                  data-mobile-cols="1"
                >
                  <MentoringSeriesItem series={mentoringSeries[0]} />
                  <MentoringSeriesItem series={mentoringSeries[1]} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="mentor-relationships"
        data-column-margin="default"
        data-midnight="dark"
        data-bg-mobile-hidden=""
        className="wpb_row vc_row-fluid vc_row standard_section "
        style={{ paddingTop: "0px", paddingBottom: "0px" }}
      >
        <div
          className="row-bg-wrap"
          data-bg-animation="none"
          data-bg-overlay="false"
        >
          <div className="inner-wrap">
            <div className="row-bg" />
          </div>
          <div className="row-bg-overlay" />
        </div>
        <div className="col span_12 dark left">
          <div
            className="vc_col-sm-6 wpb_column column_container vc_column_container col padding-3-percent"
            data-t-w-inherits="default"
            data-border-radius="none"
            data-shadow="none"
            data-border-animation=""
            data-border-animation-delay=""
            data-border-width="none"
            data-border-style="solid"
            data-border-color=""
            data-bg-cover=""
            data-padding-pos="all"
            data-has-bg-color="false"
            data-bg-color=""
            data-bg-opacity="1"
            data-hover-bg=""
            data-hover-bg-opacity="1"
            data-animation=""
            data-delay="0"
          >
            <div className="vc_column-inner">
              <div className="column-bg-overlay-wrap" data-bg-animation="none">
                <div className="column-bg-overlay" />
              </div>
              <div className="wpb_wrapper">
                <div className="wpb_text_column wpb_content_element ">
                  <div className="wpb_wrapper">
                    <h2>
                      Your Mentees
                      <i className="icon-default-style icon-leaf extra-color-3" />
                    </h2>
                  </div>
                </div>
                {mentees != null &&
                  mentees.map(m => {
                    return (
                      <div key={m.id}>
                        <DividerWrap />
                        <Mentee
                          mentee={m}
                          series={mentoringSeries.find(
                            s => s.id === m.seriesId
                          )}
                        />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>

          <div
            className="vc_col-sm-6 wpb_column column_container vc_column_container col padding-3-percent"
            data-t-w-inherits="default"
            data-border-radius="none"
            data-shadow="none"
            data-border-animation=""
            data-border-animation-delay=""
            data-border-width="none"
            data-border-style="solid"
            data-border-color=""
            data-bg-cover=""
            data-padding-pos="all"
            data-has-bg-color="false"
            data-bg-color=""
            data-bg-opacity="1"
            data-hover-bg=""
            data-hover-bg-opacity="1"
            data-animation=""
            data-delay="0"
          >
            <div className="vc_column-inner">
              <div className="column-bg-overlay-wrap" data-bg-animation="none">
                <div className="column-bg-overlay" />
              </div>
              <div className="wpb_wrapper">
                <div className="wpb_text_column wpb_content_element ">
                  <div className="wpb_wrapper">
                    <h2>
                      Your Mentors
                      <i className="icon-default-style fa fa-diamond extra-color-3" />
                    </h2>
                  </div>
                </div>
                {mentors != null &&
                  mentors.map(m => {
                    return (
                      <div key={m.id}>
                        <DividerWrap />
                        <Mentor
                          mentor={m}
                          series={mentoringSeries.find(
                            s => s.id === m.seriesId
                          )}
                        />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MentoringPage;
